/** Shared FundGenius drawer / panel surface classes. */
export const FUNDING_RIGHT_DRAWER_CLASS = 'funding-right-drawer funding-drawer funding-side-panel funding-client-drawer';

/** Light dim only — no blur. For centered modals that still need a subtle scrim. */
export const FUNDING_MODAL_OVERLAY_CLASS = '!bg-black/10 !backdrop-blur-none !backdrop-filter-none';

/** Product id stamped on FundGenius portaled dialog/sheet roots. */
export const FUNDGENIUS_PORTAL_PRODUCT = 'fundgenius';

/**
 * Explicit product + theme attrs for FundGenius portal roots (Dialog/Sheet).
 * Portals leave `.fundgenius-hq-shell`, so theme must be stamped on the surface.
 *
 * @param {'light' | 'dark' | string} theme
 * @returns {{ 'data-product': string, 'data-theme': 'light' | 'dark' }}
 */
export function getFundGeniusPortalAttrs(theme = 'dark') {
  const resolved = theme === 'light' ? 'light' : 'dark';
  return {
    'data-product': FUNDGENIUS_PORTAL_PRODUCT,
    'data-theme': resolved,
  };
}
